import unit_measure from '@/api/inventory/unit-measure'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: state.pagination.page,
        perPage: state.pagination.perPage,
        search: state.search
      },
      attributes
    )
    return unit_measure.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return unit_measure.store(data)
  },

  update(context, data) {
    return unit_measure.update(data)
  },

  destroy(context, id) {
    return unit_measure.destroy(id)
  }
}
